import {
  updateLabelConfig,
  labelConfigSelector,
} from '../../../../data/labelInfos/index.js'
import ShipperOptions from '../../../../data/shipperOptions.js'
import ConfigCheckbox from '../ConfigCheckbox.js'
import {useSelector} from '../../../../store.js'
import {DHL} from '../../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

const noSignature = ShipperOptions.dhl.signature_options.find(
  ({display}) => display === 'No Signature Required',
)

const LABEL_PROPERTY = 'dhl__signature_service'
const VALID_SHIPPER_TYPES = [DHL]

export default function SignatureRequired() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = SignatureRequired.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const signatureIsRequired = useSelector(
    (state) =>
      labelConfigSelector(state, {labelInfoID})[labelProperty] !==
      noSignature.value,
  )

  return (
    <ConfigCheckbox
      label="Signature Required"
      className="inline-block"
      checked={signatureIsRequired}
      onChange={(checked) => {
        const signatureService = checked ? null : noSignature.value

        updateLabelConfig(labelInfoID, {
          [labelProperty]: signatureService,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

SignatureRequired.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
